import { ArrowRightToLine, ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'
import Avatar from 'components/core/avatar'
import { Popover, PopoverContent, PopoverTrigger } from 'lib/components/popover/popover'
import { MenuItem } from '../menu-item/menu-item'
import { useUserContext } from 'providers/user-provider'
import { useCollaboratorContext } from 'providers/collaborator-context-provider'
import Button from 'components/core/button'
import { useFeatureFlagsContext } from '../feature-flags/feature-flags-provider'

export default function CollaboratorHeader({ showViewAllButton = false }: { showViewAllButton?: boolean }) {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false)
  const { user, logout } = useUserContext()
  const { showLogo, logoSrc, allCollaborationRequestsPath } = useCollaboratorContext()
  const { isFeatureFlagEnabled } = useFeatureFlagsContext()
  const isViewAllAssetsEnabled = isFeatureFlagEnabled('collaborator_view_all_assets')

  if (!isViewAllAssetsEnabled) {
    return null
  }

  return (
    <div className="tw-relative tw-flex tw-h-14 tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-neutral-200 tw-bg-white tw-px-2 md:tw-gap-4 md:tw-px-4">
      <div className="tw-flex tw-items-center">
        {showLogo && (
          <img src={logoSrc} alt="company logo" className="tw-h-8 tw-w-8 tw-object-contain md:tw-h-10 md:tw-w-10" />
        )}
      </div>
      <div className="tw-flex tw-items-center tw-gap-2">
        {showViewAllButton && (
          <a href={allCollaborationRequestsPath}>
            <Button color="neutral">View all collaboration requests</Button>
          </a>
        )}
        <Popover open={isProfileMenuOpen} onOpenChange={setIsProfileMenuOpen}>
          <PopoverTrigger asChild>
            <div className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-px-1 tw-py-0.5 tw-transition-all hover:tw-bg-neutral-100">
              <Avatar name={user?.fullName} />
              <div className="tw-hidden tw-items-center tw-gap-1 md:tw-flex">
                <div className="tw-font-semibold">{user?.fullName?.split(' ')?.[0]?.slice(0, 15)}</div>
                {isProfileMenuOpen ? <ChevronUp className="lu-sm" /> : <ChevronDown className="lu-sm" />}
              </div>
            </div>
          </PopoverTrigger>
          <PopoverContent collisionPadding={20} className="tw-w-56" intent="flyout">
            <MenuItem item={{ label: 'Logout', Icon: ArrowRightToLine }} onClick={() => logout()} />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  )
}
